import { useView, inject } from "aurelia-framework";
import FsUtility from '../../../../Lib/Fs.SmartClient.Client/FsUtility';
import { Router } from 'aurelia-router';
import { autoinject } from 'aurelia-property-injection';
import { fs } from "../../../../Config/FsConfig";
import RootDocEditorVMBase from "../../../../Lib/Fs.SmartClient.Client/RootDocEditorVMBase";
import { DialogController } from 'aurelia-dialog';
import DetailModalVM from "./DetailModalVM";
import DocEditorVMBase from "../../../../Lib/Fs.SmartClient.Client/DocEditorVMBase";
import { PLATFORM } from 'aurelia-pal';

@inject(DialogController)
@useView(PLATFORM.moduleName("Modules/Core/Components/Modal/ImportModalView.html"))
export default class ImportModalVM {
    controller: DialogController;
    okbtn: string = "OK";
    okbtnclass: string = "btn btn-default";
    cancelbtn: string = "Cancel";
    cancelbtnclass: string = "btn btn-default";
    IsShowCancel: boolean;
    viewModel: DocEditorVMBase;
    view: string;
    Header: string;
  constructor(controller: DialogController) {
        this.controller = controller;
        //this.IsShowCancel = true;
    }
  activate(data: any) {
    this.viewModel = data.viewModel;
    this.view = data.view;
    this.Header = data.Header;

        this.IsShowCancel = data.IsShowCancel;
        if (!(!data.okbtn || 0 === data.okbtn.length)) {
            this.okbtn = data.okbtn;
        }
        if (!(!data.okbtnclass || 0 === data.okbtnclass.length)) {
            this.okbtnclass = data.okbtnclass;
        }
        if (!(!data.cancelbtn || 0 === data.cancelbtn.length)) {
            this.cancelbtn = data.cancelbtn;
        }
        if (!(!data.cancelbtnclass || 0 === data.cancelbtnclass.length)) {
            this.cancelbtnclass = data.cancelbtnclass;
        }
    }

    Close() {
        //this.viewModel.CancelEdit();
        this.controller.cancel(this.viewModel);
    }

    Okay() {
        this.viewModel.EndEdit();
        if (this.viewModel.validationController != null) {
            this.viewModel.validationController.validate({ object: this.viewModel }).then(result => {
                //debugger
                //var yyy = this.viewModel.validationController.length
                if (result.valid) {
                    this.viewModel.EndEdit();
                    this.viewModel.IsItemEditing = false;
                    this.controller.ok(this.viewModel);
                }
            });

        } else {
            this.controller.ok(this.viewModel);


        }
        //    this.controller.ok(this.viewModel);
    }


}
